import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CreateEventRequest} from "../../../model/request/create-event-request.model";
import {EventResponse} from "../../../model/response/event/event-response.model";
import {FilePondFile} from "filepond";
import {EventService} from "../../../../service/api/event.service";
import {tap} from "rxjs";
import {MessageToastService} from "../../../../service/message-toast.service";
import {Router} from "@angular/router";
import {ApiResponse} from "../../../model/response/ApiResponse";

@Component({
    selector: 'app-edit-event',
    templateUrl: './edit-event.component.html',
    standalone: false
})
export class EditEventComponent implements OnInit {

  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean
  @Output('onEventSubmitted') eventSubmittedEmiter = new EventEmitter<EventResponse>()
  @Output('onCancelModal') onCancelModalEmitter = new EventEmitter()

  apiErrors: Map<string, string> = new Map<string, string>()

  constructor(
    private eventService: EventService,
    private messageService: MessageToastService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit($event: { data: CreateEventRequest; image: FilePondFile }) {
    this.apiOnEdit(this.event.id, $event.data)
  }

  private apiOnEdit(id: number, body: CreateEventRequest) {
    this.eventService.editEventData(id, body).pipe(
      tap({
        next: (response) => {
          this.messageService.success(response.message)
          this.eventSubmittedEmiter.emit(response.data)
          this.displayModal = false
        },
        error: (err: ApiResponse<any>) => {
          this.apiErrors = err?.formErrors ?? new Map()
          this.messageService.error(err?.message)
        }
      })
    ).subscribe()
  }

}
